import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import Firms from "../components/Firms";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const FirmsContainer = connect(mapStateToProps, mapDispatchToProps)(Firms);

export default FirmsContainer;


// WEBPACK FOOTER //
// ./src/containers/FirmsContainer.js